// Root domain used for per-project subdomains, e.g. sowbeez.qalvin.dev
const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || 'qalvin.dev';

// Reserved subdomains that should never be treated as a project
const RESERVED_SUBDOMAINS = ['www', 'api', 'app', 'admin'];

// Turn a project title into a URL-safe slug ("My Cool App!" -> "my-cool-app")
export const slugify = (text) =>
  String(text || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Extract a project slug from the current host (sowbeez.qalvin.dev -> "sowbeez")
export const getProjectFromSubdomain = () => {
  const hostname = window.location.hostname;
  const suffix = `.${ROOT_DOMAIN}`;

  if (hostname.endsWith(suffix)) {
    const subdomain = hostname.slice(0, -suffix.length);
    if (subdomain && !RESERVED_SUBDOMAINS.includes(subdomain)) {
      return subdomain;
    }
  }

  return null;
};

// Display name from a slug ("my-cool-app" -> "My Cool App")
export const formatProjectName = (name) =>
  String(name || '')
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

// Canonical shareable URL for a project (subdomain form)
export const getProjectUrl = (projectSlug) => `https://${projectSlug}.${ROOT_DOMAIN}`;
